<template>
  <div id="app">
    <global-header></global-header>
    <div id="nav">
      <!--<router-link to="/">Home</router-link> |-->
      <router-link to="/archives">Archives</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/>
    <global-footer></global-footer>
  </div>

</template>

<script>
import header from "./views/header";
import footer from "./views/footer";
export default {
  components: {
    'global-header': header,
    'global-footer': footer
    //VueMarkdown  // 声明组件
  }
}
</script>

<style>
#nav{
   font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
/*
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
*/
</style>
